import React, { useState } from "react";

function AllVan() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const vehicleCategories = {
    rideSharing: {
      title: "City & Outstation Rides",
      vehicles: [
        {
          name: "Bike",
          image:
            "https://res.cloudinary.com/dexterous-technology/image/upload/v1725596710/yellow-scooter-white-background_978521-58249-removebg-preview_khat8n.png",
          capacity: "1 passenger",
        },
        {
          name: "Auto",
          image:
            "https://res.cloudinary.com/dexterous-technology/image/upload/v1725605497/328474138abea310481783b232f46e74-removebg-preview_cp6a81.png",
          capacity: "3 passengers",
        },
        {
          name: "Mini",
          image:
            "https://res.cloudinary.com/dwul9t3bc/image/upload/v1758960031/News/Slider/dil2hzpu01ps6oujzoam.png",
          capacity: "4 passengers",
        },
        {
          name: "Sedan",
          image:
            "https://res.cloudinary.com/dzuza3qws/image/upload/v1759293538/pvra2vdzwwjii6bppcft.png",
          capacity: "4 passengers",
        },
      ],
    },
    goodsDelivery: {
      title: "Goods Delivery Vehicles",
      vehicles: [
        {
          name: "2 Wheeler",
          image: "/asessts/Images/2wheeler-goods.png",
          capacity: "Small packages",
        },
        {
          name: "3 Wheeler",
          image: "/asessts/Images/3wheeler-goods.png",
          capacity: "Medium loads",
        },
        {
          name: "Tata Ace",
          image:
            "https://res.cloudinary.com/dexterous-technology/image/upload/v1724301110/pickup_vepkll.png",
          capacity: "1-2 ton capacity",
        },
        {
          name: "Big Trucks",
          image:
            "https://res.cloudinary.com/dexterous-technology/image/upload/v1724301061/truck_wwjjjs.png",
          capacity: "5+ ton capacity",
        },
      ],
    },
    waterTankers: {
      title: "Water Tankers",
      vehicles: [
        {
          name: "Small Tanker",
          image: "/asessts/Images/small-tanker.png",
          capacity: "2,000 - 10,000L",
        },
        {
          name: "Medium Tanker",
          image: "/asessts/Images/medium-tanker.png",
          capacity: "10,000 - 15,000L",
        },
        {
          name: "Large Tanker",
          image: "/asessts/Images/large-tanker.png",
          capacity: "15,000 - 30,000L",
        },
      ],
    },
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(vehicleCategories[category]);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedCategory(null);
  };

  const handleDownloadApp = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.DriveOme.com",
      "_blank"
    );
  };

  return (
    <div className="allvancontainer">
      <div className="headingvan">
        <h1>All Vehicle Types in One App</h1>
      </div>

      <div className="vechile-contianer">
        {/* Ride Sharing */}
        <div
          className="vechile-card"
          onClick={() => handleCategoryClick("rideSharing")}
        >
          <div className="img-container">
            <img
              src="/asessts/Images/sharing.png"
              className="img-fluid"
              alt="Ride Sharing"
              width={"270px"}
            />
          </div>
          <div className="bike mt-3">
            <h2 style={{ fontWeight: "400", color: "#1B1B1B" }}>
              City & Outstation Rides
            </h2>
          </div>
          <div className="documents mt-3">
            <p className="fw-bold" style={{ color: "#5E5E5E" }}>
              For: Personal Travel, Office Commute, Airport Rides, City Tours
            </p>
            <p className="capacity">
              Seating: 4-6 passengers <br />
              <span>Comfortable & safe rides</span>
            </p>
          </div>
        </div>

        {/* Goods Delivery */}
        <div
          className="vechile-card"
          onClick={() => handleCategoryClick("goodsDelivery")}
        >
          <div className="img-container">
            <img
              src="https://res.cloudinary.com/dexterous-technology/image/upload/v1724301061/truck_wwjjjs.png"
              className="img-fluid"
              alt="Goods Delivery"
              width={"270px"}
            />
          </div>
          <div className="bike mt-3">
            <h2 style={{ fontWeight: "400", color: "#1B1B1B" }}>
              Goods Delivery
            </h2>
          </div>
          <div className="documents mt-3">
            <p className="fw-bold" style={{ color: "#5E5E5E" }}>
              For: Commercial Goods, Industrial Materials, Bulk Items, Retail
              Products
            </p>
            <p className="capacity">
              Capacity: Customizable <br />
              <span>Various sizes available</span>
            </p>
          </div>
        </div>

        {/* Water Tankers */}
        <div
          className="vechile-card"
          onClick={() => handleCategoryClick("waterTankers")}
        >
          <div className="img-container">
            <img
              src="/asessts/Images/waterpng.png"
              className="img-fluid"
              alt="Water Tankers"
              width={"270px"}
            />
          </div>
          <div className="bike mt-3">
            <h2 style={{ fontWeight: "400", color: "#1B1B1B" }}>
              Water Tankers
            </h2>
          </div>
          <div className="documents mt-3">
            <p className="fw-bold" style={{ color: "#5E5E5E" }}>
              For: Water Supply, Construction, Agriculture, Emergency Water
              Delivery
            </p>
            <p className="capacity">
              Capacity: 5000-10000 liters <br />
              <span>Various tank sizes available</span>
            </p>
          </div>
        </div>
      </div>

      {/* Modal for showing vehicle options */}
      {showModal && selectedCategory && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{selectedCategory.title}</h2>
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
            </div>

            <div className="vehicles-grid">
              {selectedCategory.vehicles.map((vehicle, index) => (
                <div key={index} className="vehicle-option">
                  <div className="vehicle-image">
                    <img
                      src={vehicle.image}
                      alt={vehicle.name}
                      className="img-fluid"
                    />
                  </div>
                  <div className="vehicle-info">
                    <h4>{vehicle.name}</h4>
                    <p>{vehicle.capacity}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="modal-footer">
              <button className="download-btn" onClick={handleDownloadApp}>
                Download App to Book
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .allvancontainer {
          position: relative;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }

        .modal-content {
          background: white;
          border-radius: 12px;
          padding: 30px;
          max-width: 800px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          border-bottom: 2px solid #f0f0f0;
          padding-bottom: 15px;
        }

        .modal-header h2 {
          color: #1b1b1b;
          margin: 0;
          font-weight: 500;
        }

        .close-button {
          background: none;
          border: none;
          font-size: 28px;
          cursor: pointer;
          color: #666;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-button:hover {
          color: #1b1b1b;
        }

        .vehicles-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .vehicle-option {
          text-align: center;
          padding: 20px;
          border: 2px solid #f0f0f0;
          border-radius: 8px;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .vehicle-option:hover {
          border-color: #007bff;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .vehicle-image {
          margin-bottom: 15px;
        }

        .vehicle-image img {
          max-width: 120px;
          height: 80px;
          object-fit: contain;
        }

        .vehicle-info h4 {
          margin: 0 0 8px 0;
          color: #1b1b1b;
          font-weight: 500;
        }

        .vehicle-info p {
          margin: 0;
          color: #5e5e5e;
          font-size: 14px;
        }

        .modal-footer {
          text-align: center;
          border-top: 2px solid #f0f0f0;
          padding-top: 20px;
        }

        .download-btn {
          background: linear-gradient(45deg, #007bff, #0056b3);
          color: white;
          border: none;
          padding: 12px 30px;
          border-radius: 25px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .download-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
        }

        @media (max-width: 768px) {
          .vehicles-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
          }

          .modal-content {
            padding: 20px;
          }

          .vehicle-image img {
            max-width: 100px;
            height: 70px;
          }
        }

        @media (max-width: 480px) {
          .vehicles-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}

export default AllVan;
